import React from "react";
import "./PlaceholderPage.css";

const Applicativi = () => {
    return (
        <div className="placeholder-container">
            <header className="page-header">
                <div className="header-content">
                    <div className="header-title">
                        <h2>Applicativi LF23</h2>
                        <p className="header-subtitle">Suite applicativi gestionali e operativi</p>
                    </div>
                </div>
            </header>

            <div className="content-area">
                <div className="coming-soon">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2">
                        <rect x="3" y="3" width="7" height="7"></rect>
                        <rect x="14" y="3" width="7" height="7"></rect>
                        <rect x="3" y="14" width="7" height="7"></rect>
                        <rect x="14" y="14" width="7" height="7"></rect>
                    </svg>
                    <h3>Applicativi LF23</h3>
                    <p>Sezione in sviluppo</p>
                </div>
            </div>
        </div>
    );
};

export default Applicativi;
